import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as homeActions from '../home/redux/actions';
import { ParentContentCardMultiHeader } from '../common/ParentContentCardMultiHeader';
import { Link } from 'react-router-dom';
import TooltipInfo from '../../common/docs/TooltipInfo';
import CustomLoader from '../common/CustomLoader';
import CustomReactPaginate from '../../common/custom/CustomReactPaginate';
import CollectionDetail from './collection/CollectionDetail';
import { descriptionTooltip, inUseTooltip, typeDescription } from '../../common/utils/validate';
import { isProjectReadOnly } from '../../common/utils/api_utils';

export class CollectionList extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = { searchTerm: '', limit: 25 };

  componentDidMount() {
    const { projectId, version, collections, actions, activeTab } = this.props;
    const { currentCollectionListPage, loadProjectCollectionsPending } = collections;
    if (!loadProjectCollectionsPending) {
      actions.loadProjectCollections({
        projectId,
        version,
        page: currentCollectionListPage,
        limit: this.state.limit,
        collectionType: activeTab,
      });
    }
  }

  shouldComponentUpdate = (nextProps, nextState, nextContext) => {
    const { activeTab: nextActiveTab, projectId, version, actions, collections } = nextProps;
    const { activeTab } = this.props;
    const { currentCollectionListPage, loadProjectCollectionsPending } = collections;
    if (nextActiveTab !== activeTab) {
      if (!loadProjectCollectionsPending) {
        actions.loadProjectCollections({
          projectId,
          version,
          page: currentCollectionListPage,
          limit: this.state.limit,
          collectionType: nextActiveTab,
        });
      }
    }
    return true;
  };

  updateSearchTerm = (val) => {
    this.setState({ searchTerm: val });
  };
  handleSearch = () => {
    const { projectId, version, collections, actions, activeTab } = this.props;
    const { currentCollectionListPage } = collections;
    const { searchTerm, limit } = this.state;
    actions.loadProjectCollections({
      searchTerm,
      projectId,
      version,
      page: currentCollectionListPage,
      limit,
      collectionType: activeTab,
    });
  };

  onPageChange = (val) => {
    const { projectId, version, actions, activeTab } = this.props;
    const { searchTerm, limit } = this.state;
    actions.loadProjectCollections({
      projectId,
      version,
      page: val.selected,
      limit,
      searchTerm,
      collectionType: activeTab,
    });
  };

  showCollectionDetail = () => {
    const { projectId, version, collections, actions, homeActions, common } = this.props;
    const { snippets } = this.props.home;
    const { projectCollections } = collections;
    const { updatedCollections } = common;
    const isReadOnly = isProjectReadOnly(projectId);
    if (projectCollections) {
      return (
        <tbody>
          {projectCollections
            .sort((a, b) => {
              return a.collectionIndex > b.collectionIndex
                ? 1
                : a.collectionIndex == b.collectionIndex
                ? 0
                : -1;
            })
            .map((collection) => (
              <CollectionDetail
                key={collection._id}
                collection={collection}
                projectId={projectId}
                version={version}
                actions={actions}
                homeActions={homeActions}
                snippets={snippets}
                updatedCollections={updatedCollections}
                isReadOnly={isReadOnly}
              />
            ))}
        </tbody>
      );
    }
    return '';
  };

  render() {
    const { projectId, version, collections } = this.props;
    const { loadProjectCollectionsPending, totalCollectionPages, currentCollectionListPage } =
      collections;
    const isReadOnly = isProjectReadOnly(projectId);
    return (
      <ParentContentCardMultiHeader
        isSearch={true}
        btnSize="sm"
        handleSearch={this.handleSearch}
        updateSearchTerm={this.updateSearchTerm}
        title="Collections"
        icon="collection"
        bgColor="drapcode-violet"
        projectId={projectId}
        version={version}
        CtaComponent={
          <>
            <Link
              to={isReadOnly ? '#' : `/deployment-setting/${version}/v/${projectId}/dump-export`}
              type="button"
              className={`btn btn-primary btn-md ${isReadOnly ? 'disabled' : ''}`}
              title={isReadOnly ? 'Read-Only Mode' : 'Database Export'}
              onClick={(e) => {
                if (isReadOnly) {
                  e.preventDefault();
                }
              }}
            >
              <i className="wb webconnect-database"></i>&nbsp;Database Export
            </Link>
            &nbsp;
            <Link
              to={isReadOnly ? '#' : `/collections/${version}/v/${projectId}/create`}
              className={`btn btn-theme-submit btn-md ${isReadOnly ? 'disabled' : ''}`}
              title={isReadOnly ? 'Read-Only Mode' : 'Create Collection'}
              onClick={(e) => {
                if (isReadOnly) {
                  e.preventDefault();
                }
              }}
            >
              <i className="wb webconnect-plus" /> Create Collection
            </Link>
          </>
        }
      >
        {loadProjectCollectionsPending ? (
          <div className="text-center">
            <CustomLoader loading={loadProjectCollectionsPending} size="20px" color="#303453" />
          </div>
        ) : (
          <>
            <div className="table-responsive">
              <table className="table table-bordered table-hover table-sm table-word-break">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>
                      Description{' '}
                      <TooltipInfo
                        title={descriptionTooltip('collection')}
                        headerText={`What's Description?`}
                        showHeader={true}
                        showArrow={true}
                      />
                    </th>
                    <th>
                      In Use{' '}
                      <TooltipInfo
                        title={inUseTooltip('collection')}
                        headerText={`What's In Use?`}
                        showHeader={true}
                        showArrow={true}
                      />
                    </th>
                    <th>
                      Type{' '}
                      <TooltipInfo
                        title={typeDescription}
                        headerText={`What's Collection Type?`}
                        showHeader={true}
                        showArrow={true}
                      />
                    </th>
                    <th>Action</th>
                  </tr>
                </thead>
                {this.showCollectionDetail()}
              </table>
            </div>
            {totalCollectionPages > 1 && (
              <CustomReactPaginate
                totalPages={totalCollectionPages}
                pageRangeDisplayed={5}
                marginPagesDisplayed={2}
                page={currentCollectionListPage}
                onPageChange={this.onPageChange}
              />
            )}
          </>
        )}
      </ParentContentCardMultiHeader>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
    home: state.home,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    homeActions: bindActionCreators({ ...homeActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CollectionList);
